export const sliceShareLabel = (share: number | undefined): string =>
  share === undefined ? '' : `${Math.round(share * 100)}%`;
